export default __webpack_public_path__ + "static/media/two_stone.e3a630fe.webp";